// extracted by mini-css-extract-plugin
module.exports = {"title":"Ybzyqu0q","children":"v8AFtmvI","hidden":"WNTKqKMX","hiddenMobileOnly":"_6ojwkeNS","mobileIcons":"oHhuczzZ"};